export function removeLastChar(str: string): string {
	return str.slice(0, -1);
}
